// Settings -- route /settings
//
// Canonical SettingsPage from saas-common. All groups come from the server
// manifest (GET /api/admin/settings/schema); see internal/settings/manifest.go.
// LLM / Telegram moved from custom panels to standard KindForm groups —
// they now read/write the common `settings` table directly so the runtime
// factories (llmfactory + notifyfactory) see the same rows. Only the
// schedule panel remains custom (it drives tenant-scoped cron rows that
// don't fit the generic key/value shape).

import { SettingsPage } from '@/admin-design/_common/settings'
import type { CustomRegistry } from '@/admin-design/_common/settings'
import SchedulePanel from '@/settings/custom/SchedulePanel'

const customRegistry: CustomRegistry = {
  'shopping-schedule-panel': SchedulePanel,
}

export default function Settings() {
  return <SettingsPage customRegistry={customRegistry} />
}
